import { cn } from "@/lib/utils";

const TIERS = {
  high: "bg-emerald-50 text-emerald-700 border-emerald-200",
  medium: "bg-orange-50 text-orange-700 border-orange-200",
  low: "bg-rose-50 text-rose-700 border-rose-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
};

export function tierFromScore(score) {
  if (score == null) return "neutral";
  if (score >= 70) return "high";
  if (score >= 40) return "medium";
  if (score > 0) return "low";
  return "neutral";
}

export function ScoreBadge({ score, label, tier, className, ...props }) {
  const t = tier || tierFromScore(score);
  const display = score == null ? "—" : Math.round(score);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        TIERS[t],
        className
      )}
      {...props}
    >
      {label ? <span>{label}</span> : null}
      <span>{display}</span>
    </span>
  );
}

export function PriorityPill({ priority }) {
  const map = {
    High: "bg-rose-50 text-rose-700 border-rose-200",
    Medium: "bg-orange-50 text-orange-700 border-orange-200",
    Low: "bg-blue-50 text-blue-700 border-blue-200",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold tracking-wide uppercase",
        map[priority] || map.Low
      )}
    >
      {priority}
    </span>
  );
}
